// Google Analytics 配置
export const setupGoogleAnalytics = () => {
  // 确保在浏览器环境下运行
  if (typeof document === 'undefined' || !document.head) {
    console.warn('setupGoogleAnalytics: document or document.head is not available');
    return;
  }

  try {
    // 添加 Google Tag Manager 脚本
    const script = document.createElement('script');
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-5JS8CWGEP1"; // 替换为您的 GA 测量 ID
    document.head.appendChild(script);

    // 添加 GA 配置代码
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    window.gtag = gtag; // 使 gtag 全局可用
    gtag('js', new Date());
    gtag('config', 'G-5JS8CWGEP1'); // 替换为您的 GA 测量 ID
  } catch (error) {
    console.error('Error setting up Google Analytics:', error);
  }
};

// 游戏事件跟踪
export const trackGameEvent = (action, gameTitle, category = 'Game') => {
  if (window.gtag) {
    window.gtag('event', action, {
      'event_category': category,
      'event_label': gameTitle
    });
  }
};

// 自定义事件跟踪
export const trackEvent = (action, category, label = null, value = null) => {
  if (window.gtag) {
    const eventParams = {
      'event_category': category
    };
    
    if (label) {
      eventParams.event_label = label;
    }
    
    if (value) {
      eventParams.value = value;
    }
    
    window.gtag('event', action, eventParams);
  }
}; 